const isProductOptionModelList = (productOption) => {
    return !productOption.choices.some((option) => "minimum" in option);
};
const containsListAndRange = (productOption) => {
    return (productOption.choices.some((option) => "key" in option) &&
        productOption.choices.some((option) => "minimum" in option));
};

export { containsListAndRange, isProductOptionModelList };
//# sourceMappingURL=isProductOptionModelList.mjs.map
